import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=a4ebfbc8&scoped=true&"
import script from "./Duty.vue?vue&type=script&lang=js&"
export * from "./Duty.vue?vue&type=script&lang=js&"
import style0 from "./Duty.vue?vue&type=style&index=0&id=a4ebfbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ebfbc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
